export const weatherCodes = [
	{
		icon: 'clear-sky',
		text: 'Clear Sky',
		code: 0,
	},
	{
		icon: 'clear-sky',
		text: 'Mainly Clear',
		code: 1,
	},
	{
		icon: 'overcast',
		text: 'Partly Cloudy',
		code: 2,
	},
	{
		icon: 'overcast',
		text: 'Overcast',
		code: 3,
	},

	{
		icon: 'fog',
		text: 'Fog',
		code: 45,
	},
	{
		icon: 'fog',
		text: 'Rime Fog',
		code: 48,
	},

	{
		icon: 'drizzle',
		text: 'Drizzle',
		code: 51,
	},
	{
		icon: 'drizzle',
		text: 'Drizzle',
		code: 53,
	},
	{
		icon: 'drizzle',
		text: 'Drizzle',
		code: 55,
	},

	{
		icon: 'freezing-drizzle',
		text: 'Freezing Drizzle',
		code: 56,
	},
	{
		icon: 'freezing-drizzle',
		text: 'Freezing Drizzle',
		code: 57,
	},

	{
		icon: 'rain',
		text: 'Rain',
		code: 61,
	},
	{
		icon: 'rain',
		text: 'Rain',
		code: 63,
	},
	{
		icon: 'rain',
		text: 'Rain',
		code: 65,
	},

	{
		icon: 'freezing-rain',
		text: 'Freezing Rain',
		code: 66,
	},
	{
		icon: 'freezing-rain',
		text: 'Freezing Rain',
		code: 67,
	},

	{
		icon: 'snow-fall',
		text: 'Snow Fall',
		code: 71,
	},
	{
		icon: 'snow-fall',
		text: 'Snow Fall',
		code: 73,
	},
	{
		icon: 'snow-fall',
		text: 'Snow Fall',
		code: 75,
	},

	{
		icon: 'snow-showers',
		text: 'Snow Grains',
		code: 77,
	},

	{
		icon: 'showers',
		text: 'Showers',
		code: 80,
	},
	{
		icon: 'showers',
		text: 'Showers',
		code: 81,
	},
	{
		icon: 'showers',
		text: 'Violent Showers',
		code: 82,
	},

	{
		icon: 'snow-showers',
		text: 'Snow Shower',
		code: 85,
	},
	{
		icon: 'snow-showers',
		text: 'Snow Shower',
		code: 86,
	},

	{
		icon: 'thunderstorm',
		text: 'Thunderstorm',
		code: 95,
	},

	{
		icon: 'thunderstorm',
		text: 'Thunderstorm',
		code: 96,
	},

	{
		icon: 'thunderstorm',
		text: 'Thunderstorm',
		code: 99,
	},
];
